import { Button, Icon } from '@chakra-ui/react';
import { ReactComponent as ChevronLeftIcon } from 'resources/images/chevron-left.svg';
import { routes } from 'app/routing/routesConfig';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from 'app/store';
import {
  getReleaseGuid,
  getReleaseVersion,
} from 'app/store/Releases/selectors';
import { ContentContainer } from 'app/components/Core';
import { ContentContainerType } from 'types/enums';

export const TrackListNavigation = () => {
  const releaseGuid = useAppSelector(getReleaseGuid);
  const navigate = useNavigate();
  const navigateToTrackList = () => {
    navigate(routes.release.path.replace(':guid', releaseGuid || ''));
  };

  const releaseVersion = useAppSelector(getReleaseVersion);

  return (
    <ContentContainer type={ContentContainerType.LIST} my={6} px={0} flex={0}>
      <Button
        variant="text"
        onClick={navigateToTrackList}
        leftIcon={<Icon as={ChevronLeftIcon} w={6} h={6} />}
        fontSize="md"
        fontWeight={500}
        p={0}
        h={6}
        w="fit-content"
      >
        {releaseVersion?.metadata.versionTitle}
      </Button>
    </ContentContainer>
  );
};
